/** Authorisation roles carried in the JWT (README section 3.5). */
export const UserRole = {
    CLIENT: 'CLIENT',
    CORPORATE_CLIENT: 'CORPORATE_CLIENT',
    TENANT_ADMIN: 'TENANT_ADMIN',
    TENANT_DISPATCHER: 'TENANT_DISPATCHER',
    WORKER: 'WORKER',
    SUPER_ADMIN: 'SUPER_ADMIN',
};
export const USER_ROLES = Object.values(UserRole);
/** Roles that operate inside a tenant and therefore require a tenant scope. */
export const TENANT_SCOPED_ROLES = [
    UserRole.TENANT_ADMIN,
    UserRole.TENANT_DISPATCHER,
    UserRole.WORKER,
];
/** Roles that book jobs. */
export const CLIENT_ROLES = [UserRole.CLIENT, UserRole.CORPORATE_CLIENT];
//# sourceMappingURL=roles.js.map